export const companyInfo = {
  name: 'BA Fashionwear Ltd.',
  tagline: 'Precision Manufacturing. Trusted Global Partnership.',
  description: 'BA Fashionwear Ltd. is a premier apparel manufacturing company based in Bangladesh, operating as the dedicated manufacturing facility of Beaumonde Tex Ltd. With state-of-the-art production infrastructure, a skilled workforce, and an unwavering commitment to quality, we deliver premium knit and woven apparel to leading international brands and retailers.',
  history: 'BA Fashionwear Limited, a 100% export Oriented Garments Factory with full sets of sophisticated and modern production lines in Garments making by cutting, sewing & finishing, with the aim of keeping the highest required quality while maintaining the targeted delivery date. We are a highly experienced, honest and dedicated team. Our goal is to achieve customer satisfaction through keeping our commitment. We are reliable, responsible and committed to our customers. Also, we are always available for assistance; our responses are fast, quick and informative.\n\n**Beaumonde Tex Limited (BTL)** is the Holding company of BA Fashionwear Limited. BTL is a professional Apparels Sourcing Company, established by people having long-time professional experience in the industry. BA Fashionwear Limited is one of the subsidiaries to compete on quality, service, and value.',
  mission: 'To manufacture quality garments with integrity, innovation, and timely delivery while exceeding customer expectations.',
  vision: 'To be a globally trusted apparel manufacturer, delivering excellence through quality, innovation, and sustainability.',
  values: [
    { title: 'Quality First', description: 'Uncompromising commitment to product excellence at every stage of production.' },
    { title: 'Integrity', description: 'Transparent, ethical, and responsible in all our business relationships.' },
    { title: 'Innovation', description: 'Continuously evolving our processes, technology, and capabilities.' },
    { title: 'Partnership', description: 'Building long-term relationships based on trust, reliability, and mutual growth.' },
  ],
  parentCompany: 'Beaumonde Tex Ltd.',
  established: '2021',
  location: 'Bangladesh',
  website: 'www.beaumondetex.com',
};

export const trustIndicators = [
  { icon: 'ri-check-double-line', label: 'Manufacturing Excellence' },
  { icon: 'ri-shield-check-line', label: 'Compliance Certified' },
  { icon: 'ri-links-line', label: 'Strong Supply Chain' },
  { icon: 'ri-global-line', label: 'Export Ready' },
];

export const whyUs = [
  {
    icon: 'ri-building-4-line',
    title: 'Manufacturing Excellence',
    description: 'State-of-the-art production facilities equipped with advanced machinery and technology, operated by skilled professionals dedicated to precision and quality.',
  },
  {
    icon: 'ri-timer-line',
    title: 'Reliable Delivery',
    description: 'Proven track record of on-time delivery with robust production planning, capacity management, and logistics coordination across global markets.',
  },
  {
    icon: 'ri-medal-line',
    title: 'Quality First',
    description: 'Multi-stage quality assurance with certified laboratories, industry-standard testing protocols, and experienced technical teams ensuring every shipment meets specifications.',
  },
  {
    icon: 'ri-hand-heart-line',
    title: 'Customer Partnership',
    description: 'We go beyond manufacturing — we partner with brands through dedicated account management, design collaboration, and flexible solutions tailored to buyer needs.',
  },
];

export const manufacturingStats = [
  { value: 17800, suffix: '', label: 'Sq. Ft. Factory Space', icon: 'ri-building-line' },
  { value: 247, suffix: '+', label: 'Skilled Workforce', icon: 'ri-team-line' },
  { value: 5, suffix: '', label: 'Production Lines', icon: 'ri-settings-line' },
  { value: 200, suffix: '+', label: 'Total Machines (Pcs)', icon: 'ri-tools-line' },
  { value: 200000, suffix: ' K', label: 'Monthly Capacity (Pcs)', icon: 'ri-bar-chart-line' },
  { value: 2400000, suffix: ' K', label: 'Annual Capacity (Pcs)', icon: 'ri-bar-chart-box-line' },
  { value: 10, suffix: 'M+', label: 'Yearly Export Value (USD)', icon: 'ri-money-dollar-circle-line' },
  { value: 1, suffix: '', label: 'Factory', icon: 'ri-building-4-line' },
];

export const productCategories = [
  {
    id: 'knitwear',
    name: 'Knitwear',
    description: 'Premium knit garments including T-shirts, polos, sweaters, and hoodies with fine finishing.',
    image: 'https://readdy.ai/api/search-image?query=Premium%20knitwear%20garments%20displayed%20on%20minimal%20wooden%20hangers%20against%20a%20soft%20cream%20studio%20background%2C%20soft%20diffused%20natural%20lighting%2C%20clean%20aesthetic%20commercial%20product%20photography%2C%20textile%20texture%20visible%2C%20neutral%20warm%20tones%2C%20professional%20fashion%20catalog%20style&width=800&height=600&seq=prod-knitwear-01&orientation=landscape',
  },
  {
    id: 'woven',
    name: 'Woven',
    description: 'Woven apparel such as shirts, trousers, and jackets manufactured with careful fabric handling.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20woven%20shirts%20and%20trousers%20on%20display%20in%20a%20bright%20modern%20showroom%2C%20white%20walls%20and%20warm%20wooden%20floor%2C%20soft%20even%20lighting%2C%20minimalist%20product%20display%2C%20clean%20commercial%20photography%2C%20neutral%20color%20palette&width=800&height=600&seq=prod-woven-02&orientation=landscape',
  },
  {
    id: 'denim',
    name: 'Denim',
    description: 'Durable denim garments crafted for comfort, style, and strong finishing quality.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20denim%20fashion%20displayed%20on%20minimal%20hangers%20against%20a%20light%20industrial%20studio%20background%2C%20clean%20commercial%20product%20photography%2C%20neutral%20blue%20tones%2C%20professional%20fashion%20catalog%20aesthetic&width=800&height=600&seq=prod-denim-03&orientation=landscape',
  },
  {
    id: 'sportswear',
    name: 'Sportswear',
    description: 'High-performance athletic wear designed for comfort, mobility, and durability.',
    image: 'https://readdy.ai/api/search-image?query=Performance%20activewear%20and%20sportswear%20displayed%20on%20modern%20minimal%20mannequins%2C%20clean%20white%20studio%20environment%2C%20bright%20natural%20lighting%2C%20athletic%20aesthetic%2C%20professional%20commercial%20photography%2C%20neutral%20grey%20and%20white%20color%20scheme&width=800&height=600&seq=prod-sport-04&orientation=landscape',
  },
  {
    id: 'modest-fashion',
    name: 'Modest Fashion',
    description: 'Elegant and contemporary modest wear tailored for modern styling and coverage.',
    image: 'https://readdy.ai/api/search-image?query=Contemporary%20modest%20fashion%20apparel%20displayed%20on%20minimal%20wooden%20hangers%20against%20a%20soft%20warm%20studio%20background%2C%20clean%20commercial%20product%20photography%2C%20professional%20fashion%20catalog%20style&width=800&height=600&seq=prod-modest-05&orientation=landscape',
  },
  {
    id: 'kidswear',
    name: 'Kidswear',
    description: 'Safe, comfortable, and durable children\'s apparel built for daily use.',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20childrens%20clothing%20neatly%20folded%20and%20displayed%20on%20light%20wooden%20shelves%2C%20soft%20pastel%20studio%20background%2C%20gentle%20warm%20lighting%2C%20playful%20yet%20professional%20product%20photography%2C%20clean%20aesthetic%2C%20cotton%20textiles&width=800&height=600&seq=prod-kids-06&orientation=landscape',
  },
  {
    id: 'uniform',
    name: 'Uniform',
    description: 'Professional uniforms for corporate, hospitality, and institutional needs.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20uniforms%20arranged%20neatly%20on%20a%20clean%20studio%20display%2C%20soft%20neutral%20background%2C%20modern%20commercial%20photography%2C%20professional%20fashion%20catalog%20aesthetic&width=800&height=600&seq=prod-uniform-07&orientation=landscape',
  },
  {
    id: 'others-hand-craft',
    name: 'Others: Hand Craft',
    description: 'Specialized hand-crafted pieces and artisanal finishing for distinctive fashion products.',
    image: 'https://readdy.ai/api/search-image?query=Handcrafted%20fashion%20pieces%20and%20artisan%20details%20displayed%20on%20a%20warm%20studio%20background%2C%20soft%20natural%20lighting%2C%20clean%20commercial%20photography%2C%20textile%20craftsmanship%20focus&width=800&height=600&seq=prod-handcraft-08&orientation=landscape',
  },
];

export const supplyChainSteps = [
  { step: '01', title: 'Design Development', description: 'Collaborative design support, tech pack analysis, and prototype development.' },
  { step: '02', title: 'Fabric Sourcing', description: 'Global fabric sourcing network with quality-verified mills and sustainable options.' },
  { step: '03', title: 'Accessories & Trims', description: 'Comprehensive trim sourcing including zippers, buttons, labels, and packaging.' },
  { step: '04', title: 'Sampling', description: 'Rapid sampling with fit, PP, and TOP samples across 15 dedicated lines.' },
  { step: '05', title: 'Production', description: '45 production lines with modern machinery, skilled operators, and lean manufacturing.' },
  { step: '06', title: 'Quality Inspection', description: 'Multi-point inspection system with inline, end-line, and final AQL-based audits.' },
  { step: '07', title: 'Packing & Finishing', description: 'Professional packing with buyer-specific labeling, folding, and packaging requirements.' },
  { step: '08', title: 'Shipping & Logistics', description: 'Coordinated global logistics with major freight partners and on-time delivery tracking.' },
];

export const supplyChainStats = [
  { value: 28, label: 'Countries Served' },
  { value: 50, label: 'Partner Factories' },
  { value: 120, label: 'Vendor Network' },
  { value: 98, suffix: '%', label: 'On-Time Delivery' },
];

export const valueAddedServices = [
  { icon: 'ri-brush-3-line', title: 'Embroidery', description: 'Multi-head computerized embroidery with precision detailing.' },
  { icon: 'ri-printer-line', title: 'Screen Printing', description: 'High-quality screen printing with vibrant, durable color application.' },
  { icon: 'ri-paint-line', title: 'Sublimation', description: 'Full-color sublimation printing for polyester and performance fabrics.' },
  { icon: 'ri-contrast-2-line', title: 'Heat Transfer', description: 'Professional heat transfer applications for logos, labels, and designs.' },
  { icon: 'ri-computer-line', title: 'Digital Printing', description: 'Advanced DTG and digital fabric printing for complex designs.' },
  { icon: 'ri-drop-line', title: 'Wash Effects', description: 'Specialized garment washing techniques including enzyme, acid, and pigment washes.' },
  { icon: 'ri-flashlight-line', title: 'Laser Finishing', description: 'Precision laser technology for distressing, etching, and detailing.' },
  { icon: 'ri-bear-smile-line', title: 'Accessories', description: 'Complete accessory sourcing and attachment for finished garments.' },
  { icon: 'ri-heart-line', title: 'Hand Craft', description: 'Skilled handwork including embroidery, beading, and artisanal detailing.' },
  { icon: 'ri-gift-line', title: 'Custom Packaging', description: 'Bespoke packaging solutions including hang tags, poly bags, and box packaging.' },
  { icon: 'ri-lightbulb-line', title: 'Product Development', description: 'End-to-end product development from concept to commercialization.' },
  { icon: 'ri-ruler-line', title: 'Pattern Making', description: 'CAD-based pattern making and grading for precise garment construction.' },
  { icon: 'ri-scissors-cut-line', title: 'Sampling', description: 'Rapid prototype and production sampling with quick turnaround.' },
  { icon: 'ri-microscope-line', title: 'R&D', description: 'Continuous research in fabrics, finishes, and sustainable manufacturing methods.' },
];

export const qualitySteps = [
  { phase: 'Phase 1', title: 'Incoming Inspection', description: 'All raw materials, fabrics, and accessories undergo thorough inspection before entering production.' },
  { phase: 'Phase 2', title: 'Inline Inspection', description: 'Continuous quality monitoring at every production stage with real-time defect tracking.' },
  { phase: 'Phase 3', title: 'Final Inspection', description: 'Comprehensive AQL-based final inspection covering measurements, workmanship, and appearance.' },
  { phase: 'Phase 4', title: 'Lab Testing', description: 'In-house laboratory testing for colorfastness, shrinkage, strength, and chemical compliance.' },
  { phase: 'Phase 5', title: 'Shipment Approval', description: 'Final audit and approval before shipment release, ensuring complete buyer specification compliance.' },
];

export const qualityKPIs = [
  { label: 'Quality Pass Rate', value: 99.2 },
  { label: 'Customer Satisfaction', value: 97.8 },
  { label: 'On-Time Inspection', value: 100 },
  { label: 'RFT Rate', value: 96.5 },
];

export const certifications = [
  { name: 'ISO 9001:2015', description: 'Quality Management System', icon: 'ri-medal-line' },
  { name: 'BSCI', description: 'Business Social Compliance Initiative', icon: 'ri-shield-star-line' },
  { name: 'SEDEX', description: 'Supplier Ethical Data Exchange', icon: 'ri-database-2-line' },
  { name: 'WRAP', description: 'Worldwide Responsible Accredited Production', icon: 'ri-global-line' },
  { name: 'OEKO-TEX', description: 'Standard 100 — Textile Safety', icon: 'ri-leaf-line' },
  { name: 'GOTS', description: 'Global Organic Textile Standard', icon: 'ri-plant-line' },
  { name: 'GRS', description: 'Global Recycled Standard', icon: 'ri-recycle-line' },
  { name: 'RSC', description: 'Responsible Supply Chain', icon: 'ri-link' },
  { name: 'RCS', description: 'Recycled Claim Standard', icon: 'ri-restart-line' },
];

export const complianceAreas = [
  { icon: 'ri-user-heart-line', title: 'Worker Welfare', description: 'Safe working conditions, fair wages, healthcare, and dignified employment for all workers.' },
  { icon: 'ri-fire-line', title: 'Fire Safety', description: 'NFPA-compliant fire detection, suppression systems, and regular safety drills across facilities.' },
  { icon: 'ri-test-tube-line', title: 'Chemical Management', description: 'ZDHC-aligned chemical management ensuring safe handling and restricted substance compliance.' },
  { icon: 'ri-group-line', title: 'Social Responsibility', description: 'Active community engagement, education support, and social development initiatives.' },
];

export const sustainabilityInitiatives = [
  { icon: 'ri-water-flash-line', title: 'Water Stewardship', description: 'Advanced ETP with water recycling capabilities, reducing freshwater consumption by 40%.' },
  { icon: 'ri-sun-line', title: 'Energy Efficiency', description: 'Solar energy integration and energy-efficient machinery reducing carbon footprint significantly.' },
  { icon: 'ri-delete-back-line', title: 'Waste Reduction', description: 'Zero-waste-to-landfill initiative with fabric recycling and responsible waste management systems.' },
  { icon: 'ri-empathize-line', title: 'Worker Wellbeing', description: 'Comprehensive worker programs including healthcare, childcare, transportation, and skill development.' },
  { icon: 'ri-home-heart-line', title: 'Community Impact', description: 'Active investment in local communities through education, infrastructure, and employment opportunities.' },
  { icon: 'ri-loop-left-line', title: 'Circularity', description: 'Pioneering circular fashion initiatives including recycled fiber programs and closed-loop production.' },
  { icon: 'ri-hand-heart-line', title: 'Ethical Sourcing', description: 'Rigorous supply chain mapping ensuring ethical sourcing of all raw materials and components.' },
];

export const exportMarkets = [
  'United Kingdom', 'Germany', 'France', 'Italy', 'Spain',
  'Netherlands', 'Belgium', 'Sweden', 'Denmark', 'Norway',
  'United States', 'Canada', 'Australia', 'Japan', 'South Korea',
  'UAE', 'Saudi Arabia', 'South Africa', 'Brazil', 'Mexico',
  'Poland', 'Austria', 'Switzerland', 'Ireland', 'Finland',
  'Portugal', 'Greece', 'New Zealand',
];

export const leadership = [
  {
    name: 'Md. Shahmij Bokul',
    role: 'Managing Director (MD)',
    image: '/images/MD.jpeg',
  },
  {
    name: 'Mohammad Abidur Rahman',
    role: 'Chairman',
    image: '/images/chairman.jpeg',
  },
  
];

export const galleryImages = [
  { src: '/images/fa1.jpg', alt: 'Production Floor' },
  { src: '/images/fa1.JPG', alt: 'Quality Lab' },
  { src: '/images/fa2.jpeg', alt: 'Warehouse' },
  { src: '/images/fa2.jpg', alt: 'Advanced Machinery' },
  { src: '/images/fa5.jpg', alt: 'Skilled Workforce' },
  { src: '/images/fa6.jpg', alt: 'Finishing Section' },
];

export const newsItems = [
  {
    id: 'news-1',
    date: '2026-06-15',
    category: 'Small Cottage Industry',
    title: 'BGMEA nominates industry leader to support small cottage industry growth',
    excerpt: 'The Bangladesh Garment Manufacturers and Exporters Association (BGMEA) has nominated Md. Shahmij Bokul, Managing Director of B A Fashionwear Ltd., as Chairman of the BGMEA Standing Committee on Small Cottage Industry.',
    image: 'https://textiletoday.com.bd/storage/uploads/2026/6/5272koEAtXzvQqucCuJL.jpeg',
  }
  
];

export const contactInfo = {
  factoryAddress: 'BA Fashionwear Ltd., Haji Bari, Uttarkhan, Maddha Para, Post- Uttarkhan Majar, PS - Uttar Khan, Dhaka - 1230; Bangladesh',
  officeAddress: 'Head Office: Asset Nahiyan, Plot-03, Gareeb-E-Newaz Avenue, Sector-11, Uttara, Dhaka, Bangladesh',
  phone: '+8801674283025',
  email: 'inquiry@bafashionwear.com',
  whatsapp: '+8801674283025',
  website: 'www.beaumondetex.com',
  linkedin: 'https://linkedin.com/company/ba-fashionwear',
  googleMapsEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d58382.24571112017!2d90.2563445!3d23.8595949!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c7f2c6b7e3e3%3A0x8f4b5a8e5c3d1e2!2sSavar%2C%20Dhaka%2C%20Bangladesh!5e0!3m2!1sen!2sus!4v1689123456789!5m2!1sen!2sus',
};

export const navLinks = [
  { label: 'Home', href: '/#home' },
  { label: 'About', href: '/about' },
  { label: 'Capabilities', href: '/#capabilities' },
  { label: 'Products', href: '/#products' },
  { label: 'Quality', href: '/#quality' },
  {
    label: 'Sister Concerns',
    href: '#',
    children: [
      { label: 'BA Fashionwear Ltd.', href: '/sister-concerns/garments' },
      { label: 'BTL Trims Accessories', href: '/sister-concerns/accessories' },
      { label: 'Beaumonde Tex Ltd.', href: '/sister-concerns/printing-dyeing' },
      { label: 'Kiddo Outfit', href: '/sister-concerns/packaging' },
    ],
  },
  { label: 'News', href: '/#news' },
  { label: 'Contact', href: '/#contact' },
];

export const sisterConcerns = [
  {
    slug: 'garments',
    name: 'BA Fashionwear Ltd.',
    category: 'Garment Manufacturing',
    description: 'A fully integrated knit composite facility specializing in premium knit apparel with in-house knitting, dyeing, cutting, sewing, and finishing capabilities.',
    longDescription: 'BA Knit Composite Ltd. is a vertically integrated knitwear manufacturing facility under the Beaumonde Tex group. With end-to-end capabilities spanning knitting, dyeing, cutting, sewing, and finishing, we deliver premium knit garments for leading international brands. Our facility is engineered for efficiency, quality, and scale — capable of handling both high-volume basics and complex fashion knitwear with equal precision.',
    heroImage: 'https://readdy.ai/api/search-image?query=Modern%20knitwear%20garment%20factory%20interior%20with%20organized%20sewing%20production%20lines%2C%20bright%20clean%20industrial%20space%2C%20workers%20at%20stations%2C%20overhead%20LED%20lighting%2C%20professional%20manufacturing%20photography%2C%20warm%20neutral%20industrial%20atmosphere%2C%20high%20quality&width=1600&height=700&seq=sister-garments-hero&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=Industrial%20knitting%20machines%20in%20a%20clean%20modern%20textile%20factory%2C%20rows%20of%20circular%20knitting%20machines%2C%20bright%20industrial%20lighting%2C%20organized%20workspace%2C%20professional%20manufacturing%20photography&width=600&height=450&seq=sister-garments-01&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Fabric%20dyeing%20facility%20with%20modern%20dyeing%20machines%20and%20color%20matching%20station%2C%20clean%20industrial%20environment%2C%20bright%20lighting%2C%20quality%20control%20in%20progress%2C%20professional%20textile%20industry%20photography&width=600&height=450&seq=sister-garments-02&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Garment%20cutting%20room%20with%20automated%20fabric%20spreading%20and%20cutting%20tables%2C%20organized%20fabric%20rolls%2C%20clean%20industrial%20workspace%2C%20professional%20apparel%20manufacturing%20photography&width=600&height=450&seq=sister-garments-03&orientation=landscape',
    ],
    stats: [
      { value: 180, suffix: 'K', label: 'Sq. Ft. Facility' },
      { value: 800, suffix: '+', label: 'Workforce' },
      { value: 28, suffix: '', label: 'Production Lines' },
      { value: 500, suffix: 'K', label: 'Monthly Capacity (Pcs)' },
    ],
    features: [
      'In-house circular and flatbed knitting',
      'Computerized fabric dyeing with precise color matching',
      'Automated cutting with CAD pattern integration',
      'Multi-style sewing lines for t-shirts, polo, sweats, and fashion knitwear',
      'Specialized finishing including compacting, brushing, and peaching',
      'In-house embroidery and printing attachments',
      'Dedicated sampling and product development center',
      'Real-time production tracking and ERP integration',
    ],
  },
  {
    slug: 'accessories',
    name: 'BTL Trims Accessories',
    category: 'Accessories Sourcing and Manufacturing',
    description: 'Manufacturer of garment accessories including zippers, buttons, labels, hang tags, elastic, drawstrings, and packaging materials for the apparel industry.',
    longDescription: 'Beaumonde Accessories Ltd. is the dedicated trims and accessories manufacturing arm of the Beaumonde Tex group. We produce a comprehensive range of garment accessories — from zippers and buttons to labels and packaging — ensuring seamless integration with apparel production. Our facility combines precision manufacturing with rigorous quality control, giving brands a reliable single-source partner for all accessory needs.',
    heroImage: 'https://readdy.ai/api/search-image?query=Garment%20accessories%20and%20trims%20manufacturing%20workshop%2C%20organized%20displays%20of%20buttons%20zippers%20labels%20and%20elastic%2C%20clean%20modern%20industrial%20space%2C%20bright%20lighting%2C%20professional%20product%20photography%2C%20warm%20neutral%20tones&width=1600&height=700&seq=sister-accessories-hero&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=Zipper%20manufacturing%20process%20with%20precision%20machinery%2C%20metal%20and%20plastic%20zipper%20production%20line%2C%20clean%20industrial%20facility%2C%20bright%20lighting%2C%20professional%20manufacturing%20photography&width=600&height=450&seq=sister-accessories-01&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Button%20and%20snap%20fastener%20production%20workshop%2C%20organized%20workstations%20with%20molding%20machines%2C%20clean%20industrial%20environment%2C%20professional%20product%20manufacturing%20photography&width=600&height=450&seq=sister-accessories-02&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Printed%20labels%20and%20hang%20tags%20production%20facility%2C%20modern%20printing%20equipment%2C%20organized%20sample%20displays%2C%20bright%20clean%20workshop%2C%20professional%20photography&width=600&height=450&seq=sister-accessories-03&orientation=landscape',
    ],
    stats: [
      { value: 60, suffix: 'K', label: 'Sq. Ft. Facility' },
      { value: 300, suffix: '+', label: 'Workforce' },
      { value: 15, suffix: '', label: 'Production Lines' },
      { value: 50, suffix: 'M', label: 'Monthly Units' },
    ],
    features: [
      'Metal and plastic zipper manufacturing (YKK-grade)',
      'Button production: resin, metal, horn, and shell',
      'Woven labels, printed labels, and heat transfer labels',
      'Hang tags, price tickets, and barcode stickers',
      'Elastic, drawstring, and cord production',
      'Poly bags, cartons, and retail packaging',
      'Custom branding with embossing, debossing, and foil stamping',
      'OEKO-TEX certified materials available',
    ],
  },
  {
    slug: 'printing-dyeing',
    name: 'Beaumonde Tex Ltd.',
    category: 'Sourcing & Buying',
    description: 'State-of-the-art printing and dyeing facility offering screen printing, digital printing, sublimation, fabric dyeing, and specialized wash effects.',
    longDescription: 'Modern Print & Dye Ltd. is the group’s specialized surface-decoration and coloration facility. We handle everything from solid fabric dyeing to complex multi-color prints across all fabric types. With advanced digital, screen, and sublimation printing technologies alongside comprehensive dyeing and washing capabilities, we give apparel brands unmatched creative flexibility for surface design and garment finishing.',
    heroImage: 'https://readdy.ai/api/search-image?query=Modern%20textile%20printing%20facility%20with%20large%20format%20digital%20printers%20and%20screen%20printing%20stations%2C%20vibrant%20fabric%20samples%20on%20display%2C%20bright%20clean%20industrial%20space%2C%20professional%20photography%2C%20creative%20atmosphere&width=1600&height=700&seq=sister-printing-hero&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=Large%20format%20digital%20textile%20printing%20machines%20in%20operation%2C%20vibrant%20colors%20on%20fabric%2C%20modern%20clean%20facility%2C%20bright%20industrial%20lighting%2C%20professional%20printing%20industry%20photography&width=600&height=450&seq=sister-printing-01&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Screen%20printing%20workshop%20with%20multiple%20stations%2C%20frames%20and%20squeegees%2C%20colorful%20ink%20displays%2C%20organized%20industrial%20workspace%2C%20professional%20photography&width=600&height=450&seq=sister-printing-02&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Industrial%20fabric%20dyeing%20facility%20with%20large%20dyeing%20vats%20and%20color%20lab%2C%20organized%20chemical%20storage%2C%20clean%20modern%20environment%2C%20professional%20textile%20industry%20photography&width=600&height=450&seq=sister-printing-03&orientation=landscape',
    ],
    stats: [
      { value: 80, suffix: 'K', label: 'Sq. Ft. Facility' },
      { value: 350, suffix: '+', label: 'Workforce' },
      { value: 20, suffix: '', label: 'Print Lines' },
      { value: 300, suffix: 'K', label: 'Monthly Capacity (Pcs)' },
    ],
    features: [
      'High-speed rotary screen printing (up to 12 colors)',
      'DTG (Direct-to-Garment) digital printing',
      'Sublimation printing for polyester and performance fabrics',
      'Reactive, pigment, and disperse fabric dyeing',
      'Specialty washes: enzyme, acid, pigment, silicone, and ozone',
      'Laser etching, distressing, and decorative finishing',
      'Foil, flock, and puff printing for premium effects',
      'In-house color lab with spectrophotometer matching',
    ],
  },
  {
    slug: 'kids',
    name: 'Kiddo Outfit',
    category: 'Trusted Clothing Solution For Kids',
    description: 'End-to-end packaging solutions including poly bags, cartons, inner boxes, master cartons, hang tags, and brand-specific retail packaging for export.',
    longDescription: 'Kiddo Outfit. provides complete packaging solutions for the apparel export industry. From poly bags and inner boxes to branded retail packaging and master cartons, we ensure that every garment reaches its destination in perfect condition. Our facility is designed for speed and customization — handling everything from standard export packaging to fully bespoke brand experiences with custom printing, embossing, and sustainable material options.',
    heroImage: 'https://readdy.ai/api/search-image?query=Modern%20packaging%20manufacturing%20facility%20with%20carton%20production%20line%20and%20printed%20packaging%20samples%2C%20organized%20workspace%2C%20bright%20clean%20industrial%20environment%2C%20professional%20product%20photography%2C%20warm%20neutral%20tones&width=1600&height=700&seq=sister-packaging-hero&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=Carton%20and%20box%20manufacturing%20production%20line%2C%20corrugated%20board%20processing%2C%20modern%20machinery%2C%20clean%20organized%20factory%20floor%2C%20professional%20industrial%20photography&width=600&height=450&seq=sister-packaging-01&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Printed%20poly%20bag%20production%20with%20various%20sizes%20and%20designs%2C%20modern%20plastic%20packaging%20facility%2C%20organized%20workspace%2C%20bright%20industrial%20lighting%2C%20professional%20photography&width=600&height=450&seq=sister-packaging-02&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Custom%20retail%20packaging%20with%20branded%20boxes%20tissue%20paper%20and%20hang%20tags%2C%20elegant%20product%20presentation%2C%20professional%20commercial%20photography%2C%20clean%20studio%20environment&width=600&height=450&seq=sister-packaging-03&orientation=landscape',
    ],
    stats: [
      { value: 55, suffix: 'K', label: 'Sq. Ft. Facility' },
      { value: 200, suffix: '+', label: 'Workforce' },
      { value: 12, suffix: '', label: 'Production Lines' },
      { value: 100, suffix: 'M', label: 'Monthly Units' },
    ],
    features: [
      'Poly bags: plain, printed, biodegradable options',
      'Corrugated cartons and master cartons (single/double/triple wall)',
      'Inner boxes, dividers, and partitions',
      'Branded retail boxes with custom printing and finishing',
      'Tissue paper, stickers, and seal tapes',
      'Hang tags with string, safety pin, or plastic attachment',
      'Barcode labels and RFID tags',
      'FSC-certified and recycled material options available',
    ],
  },
];

export const aboutTimeline = [
  {
    year: '2008',
    title: 'Foundation of Beaumonde Tex',
    description: 'Beaumonde Tex Ltd. established as a global apparel sourcing and trading company, building relationships with international buyers.',
  },
  {
    year: '2010',
    title: 'BA Fashionwear Established',
    description: 'Manufacturing facility launched in Savar, Dhaka as the dedicated production arm of Beaumonde Tex, beginning with 8 production lines.',
  },
  {
    year: '2012',
    title: 'First International Certification',
    description: 'Achieved ISO 9001:2015 certification, marking our formal commitment to quality management systems.',
  },
  {
    year: '2014',
    title: 'Factory Expansion Phase I',
    description: 'Doubled production capacity to 20 lines, added dedicated sampling and product development facilities.',
  },
  {
    year: '2016',
    title: 'Compliance Milestone',
    description: 'Achieved BSCI and SEDEX certifications, reinforcing our commitment to ethical manufacturing.',
  },
  {
    year: '2018',
    title: 'Sustainability Integration',
    description: 'Installed ETP with water recycling, launched energy efficiency programs, began organic production capabilities.',
  },
  {
    year: '2020',
    title: 'Global Recognition',
    description: 'Expanded export markets to 20+ countries, earned WRAP certification, navigated pandemic challenges with resilient operations.',
  },
  {
    year: '2022',
    title: 'Factory Expansion Phase II',
    description: 'Expanded to 45 production lines, added advanced automation and digital printing capabilities.',
  },
  {
    year: '2024',
    title: 'GOTS & GRS Certified',
    description: 'Achieved GOTS and GRS certifications, launched dedicated sustainable production lines with recycled fiber programs.',
  },
  {
    year: '2026',
    title: 'Looking Forward',
    description: 'Continuing to expand capacity, deepen sustainability commitments, and strengthen global partnerships for the next decade of growth.',
  },
];